module.exports = __webpack_public_path__ + "static/img/link2.e582521.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/link2.png
// module id = jG7l
// module chunks = 0